import React from "react";
import PropTypes from "prop-types";
import { Alert, AlertDescription, AlertIcon, AlertTitle } from "@chakra-ui/react";
import { FormatLabel } from "Utils/formatLabel.js";
import { nanoid } from "nanoid/non-secure";

export default class ErrorBoundary extends React.PureComponent {
    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    static get propTypes() {
        return {
            children: PropTypes.node.isRequired,
            className: PropTypes.string
        };
    }

    static get defaultProps() {
        return {
            className: ""
        };
    }

    constructor(props) {
        super(props);
        this.state = { hasError: false, errorId: nanoid() };
    }

    componentDidCatch(error, errorInfo) {
        const { errorId } = this.state;
        console.error(error, errorInfo, { id: errorId });
    }

    render() {
        const { hasError, errorId,  } = this.state;
        const { children, className } = this.props;
        if (hasError) {
            // You can render any custom fallback UI
            return (
                <Alert
                    className={className}
                    status="error"
                    variant="subtle"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    textAlign="center"
                    py={10}
                >
                    <AlertIcon boxSize={14} mr={0} />
                    <AlertTitle mt={4} mb={1} fontSize="lg">
                        <FormatLabel
                            id="app.error.title"
                            description="Error title for fatal crash to part of the app"
                            defaultMessage="There was an unexpected error."
                            values={{}}
                        />
                    </AlertTitle>
                    <AlertDescription maxWidth="sm">
                        <FormatLabel
                            id="app.error.message"
                            // eslint-disable-next-line max-len
                            description="Error message for fatal crash to part of the app. errorId is a unique id used to identify this error in analytics"
                            // eslint-disable-next-line max-len
                            defaultMessage="Try reloading the page. If this error persists, please contact the MasterDocs help-desk referencing error {errorId}."
                            values={{
                                errorId
                            }}
                        />
                    </AlertDescription>
                </Alert>
            );
        }
        return children;
    }
}
